import Hero from '../ckan/Herov2';
import Highlight from '../solutions/Highlight.jsx'
import ValuePropositions from '../ckan/ValuePropositions.jsx'
import SocialProof from '../ckan/SocialProof';
import Features from '../ckan/Features.jsx';
import MoreFeatures from './MoreFeatures';
import CaseStudiesSection from '../solutions/CaseStudiesSection';
import Link from 'next/link';

export default function DataEngineering({blogs, casestudies}) {

  const values= [
    {
      title: "Delivered by experts",
      text: "Our team of data engineers from across the globe have decades of experience to bring to your business.",
    },
      {
      title: "Build robust systems",
      text: "We use the best software practices, from test-driven development to continuous integration to creating reliable, scalable systems.",
    },
    {
      title: "Eliminate data friction",
      text: "As the creators of the <a href='https://frictionlessdata.io/' target='_blank'><span>Frictionless Data</span></a> toolkit, we know how to make sure that data flows seamlessly throughout your systems.",
    },
  ]

  const features = [
    {
      title: 'System Design',
      text: "Our experts design scalable, fit-for-purpose systems that meet your business needs and drive success.",
      icon: "/assets/icons/paint-roller.json"
    },
    { 
      title: 'Custom Data Workflows', 
      text: "Design workflows to support human-machine interaction and data governance, including fully automated and human-in-the-middle approaches tailored to your requirements.",
      icon: "/assets/icons/flow-chart.json"
    },
    {
      title: 'Data Specification(s)',
      text: "Leverage data specifications to enhance data quality and facilitate interoperability across systems and people, using the <a href='https://frictionlessdata.io/' target='_blank' ><span>Frictionless</span></a> framework and other tools.",
      icon: "/assets/icons/scroll.json"
    },
    {
      title: 'Integration and Interoperability',
      text: "Experience seamless data access over heterogeneous data sources and data types, ensuring smooth operation and single-point access for users.",
      icon: "/assets/icons/international.json"
    },
    {
      title: 'Data Pipelining and ETL',
      text: "Move and transform data with modular, scalable pipelines and tooling for optimal performance.",
      icon: "/assets/icons/api.json"
    },
    {
      title: 'Data Analytics and Visualization',
      text: "Empower your team with actionable insights through advanced data analytics and visualizations, driving informed decision-making.",
      icon: "/assets/icons/bar-chart.json"
    },
  ]

  return (
    <section className="bg-homeExpert bg-no-repeat bypass-filter bg-engineeringPosition !overflow-x-hidden"
    >
      <section>
        <Hero topTitle="Data Engineering" title="Experts on demand to build your next data solution. Years of experience available in minutes." subtitle="Whether your data is big or small, we design and build robust systems and dataflows with your business goals in mind." />
      </section>

      <section className='pt-8'>
        <SocialProof />
      </section>
      
      <section className=' relative w-screen max-w-screen overflow-hidden lg:flex-row bg-gradient-to-b from-transparent to-[#F7F8F9]'>
          <Highlight subtitle="WHY CHOOSE US" topTitle="We deliver tailored solutions utilizing agile practices"
          text="We create custom data engineering solutions that meet your unique business requirements following agile development practices to ensure rapid delivery of high-quality solutions."
        />
      </section>

      <section >
        <ValuePropositions topTitle="Experience the Datopian advantage" title="Transform your data infrastructure, accelerate insights, and drive innovation with our end-to-end data engineering services."
          valuePropositions={values} />
      </section>

      <section >
       <Features topTitle="Crafting your data success story" title="Benefit from our broad range of data engineering competencies, expertly tailored to advance data management, bolster interoperability, and support informed decision-making." featuredItems={features}/>
      </section>

      <section >
        <MoreFeatures />
      </section>

      <section>
        <CaseStudiesSection blogs={casestudies} subtitle="DATA ENGINEERING" catalog="data-engineering" />
      </section>


      <section className='bg-[#F7F8F9] py-20 relative w-screen max-w-screen overflow-hidden' tabIndex={0}>
        <h3 className='text-center mx-auto medium-title font-["Inter"] text-maingray'  >Data can fuel your growth. Let us show you how.</h3>
        <p className='text-center font-["Inter"] text-maingray mt-4 px-8 sm:px-0 mx-auto xl:max-w-4xl lg:max-w-3xl md:max-w-2xl max-w-sm'>Unlock your business potential with our expertise. Join thousands of happy customers. </p>
        <div className='flex flex-col  sm:flex-row mt-8 gap-y-8 sm:gap-x-8 w-full justify-center px-8 sm:px-0 mx-auto xl:max-w-4xl lg:max-w-3xl md:max-w-2xl max-w-sm'>
         <div className='btn-primary'><Link href="/contact">Email us</Link></div>
        <div className='btn-primary'><Link href="https://calendar.app.google/LT4acVdKn3Cxm2MXA" target="_blank">Schedule a free call</Link></div>
        </div>
      </section>


    </section>
  );
}